import React, { useState } from "react";
import PDFGenerator from "./PDFGenerator"; // Assuming you have this component
import { processInvoiceData } from "./utils";
import { makeCreateInvoiceReport } from "../../pages/Api";
import ConfirmModal from "../popup/MainPopUp";
import PDFGeneratorDuna from "./PDFGeneratorDuna";

const MergedInvoiceTable = ({ data, setMergedInvoices, mergedKeys,invoiceNum, resetData }) => {
  const [isChecked, setIsChecked] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const parseNumber = (value) => parseFloat(value?.toString().replace(/,/g, "")) || 0;

  const recalculateValues = (row) => {
    const rate = parseNumber(row.ZRATE);
    const quantity = parseNumber(row.FKIMG);
    const discount = parseNumber(row.ZDISC);
    const vatPercentage = parseNumber(row.ZPVAT);

    // Calculate Price After Discount
    const priceAfterDiscount = rate * quantity - discount;

    // Calculate VAT Amount
    const vatAmount = (priceAfterDiscount * vatPercentage) / 100;

    // Calculate Total Amount
    const totalAmount = priceAfterDiscount + vatAmount;

    return {
      ...row,
      ZPDISC: priceAfterDiscount.toFixed(2),
      ZVAT: vatAmount.toFixed(2),
      ZTAMT: totalAmount.toFixed(2),
    };
  };

  const handleInputChange = (e, index, field) => {
    let value = e.target.value;
  
    // Convert only numeric fields to float, keep text fields as is
    const numericFields = ["ZRATE", "FKIMG", "ZDISC", "ZPVAT"];
    if (numericFields.includes(field)) {
      value = parseFloat(value) || "";
    }
  
    const updatedData = [...data];
    updatedData[index][field] = value;
  
    // Recalculate dependent fields only for numeric input changes
    if (numericFields.includes(field)) {
      updatedData[index] = recalculateValues(updatedData[index]);
    }
  
    setMergedInvoices(updatedData);
  };
  

  const handleEditableFieldChange = (e, index, field) => {
    const value = parseFloat(e.target.value) || "";
    const updatedData = [...data];
    updatedData[index][field] = value;

    setMergedInvoices(updatedData);
  };

  const handleAddRow = () => {
    const newRow = {
      VBELN: "",
      MATNR: "",
      ARKTX: "",
      ZRATE: 0,
      ZDISC: 0,
      FKIMG: 0,
      ZPDISC: 0,
      ZPVAT: 0,
      ZVAT: 0,
      ZTAMT: 0,
      new:true
    };
    const updatedData = [...data, newRow];
    setMergedInvoices(updatedData);
  };

  const handleDeleteRow = (index) => {
    const updatedData = data.filter((_, i) => i !== index);
    setMergedInvoices(updatedData);
  };

  const handleCapitalizedInputChange = (e, index, field, handler) => {
    const capitalizedValue = e.target.value.toUpperCase();
    handler({ ...e, target: { ...e.target, value: capitalizedValue } }, index, field);
  };

  const handleSubmit = async(invoiceDetail) => {
    const submitData = processInvoiceData(data,invoiceNum,invoiceDetail)
    console.log(submitData,"asdflkaksf")
    try{
      const response = await makeCreateInvoiceReport(submitData)
      resetData() 
    }catch(error){
      console.log(error) 
    }
  }

  return (
    <div className="mt-6 p-4 bg-white shadow-md rounded-md">

      {/* Legend for Highlighted Columns */}
      <div className="mb-4 flex justify-between items-center">
      <h3 className="text-xl font-semibold text-gray-700 mb-4">Merged Invoices</h3>
      <div className="flex justify-center items-center">
          <div className="flex items-center ml-2">
            <div className="w-4 h-4 bg-blue-100 border border-gray-300 mr-2"></div>
            <span className="text-sm text-gray-700">Recalculated Values (Rate, Quantity, Discount, Vat%)</span>
        </div>
        </div>
      </div>


      <div className="overflow-x-auto">
        <table className="table-auto w-full border-collapse border border-gray-300 rounded-md">
          <thead className="bg-gray-200">
            <tr>
              <th className="border border-gray-300 px-2 py-2">Invoice No</th>
              <th className="border border-gray-300 px-2 py-2">Product No</th>
              <th className="border border-gray-300 px-2 py-2">Description</th>
              <th className="border border-gray-300 px-2 py-2 text-right bg-blue-100">Rate</th>
              <th className="border border-gray-300 px-2 py-2 text-right bg-blue-100">Discount</th>
              <th className="border border-gray-300 px-2 py-2 text-right bg-blue-100">Quantity</th>
              <th className="border border-gray-300 px-2 py-2 text-right bg-blue-100">Vat%</th>
              <th className="border border-gray-300 px-2 py-2 text-right">Vat Amount</th>
              <th className="border border-gray-300 px-2 py-2 text-right">Price After Disc</th>
              <th className="border border-gray-300 px-2 py-2 text-right">Total Amount</th>
              <th className="border border-gray-300 px-2 py-2 text-right">Action</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr
                key={index}
                className={`${
                  mergedKeys.includes(item.MATNR) ? "bg-green-100" : ""
                }`}
              >
                <td className="border border-gray-300 px-2 py-2">
                  <input
                    type="text"
                    value={item.VBELN}
                    onChange={(e) => handleCapitalizedInputChange(e, index, "VBELN", handleInputChange)}
                    className="w-full px-2                    py-1 border rounded text-sm"
                  />
                </td>
                <td className="border border-gray-300 px-2 py-2">
                  <input
                    type="text"
                    value={item.MATNR}
                    onChange={(e) => handleCapitalizedInputChange(e, index, "MATNR", handleInputChange)}
                    className="w-full px-2 py-1 border rounded text-sm"
                  />
                </td>
                <td className="border border-gray-300 px-2 py-2">
                  <input
                    type="text"
                    value={item.ARKTX}
                    onChange={(e) => handleCapitalizedInputChange(e, index, "ARKTX", handleInputChange)}
                    className="w-full px-2 py-1 border rounded text-sm"
                  />
                </td>
                <td className="border border-gray-300 px-2 py-2 text-right bg-blue-100">
                  <input
                    type="number"
                    value={parseNumber(item.ZRATE)}
                    onChange={(e) => handleInputChange(e, index, "ZRATE")}
                    className="w-full px-2 py-1 border rounded text-sm text-right"
                  />
                </td>
                <td className="border border-gray-300 px-2 py-2 text-right bg-blue-100">
                  <input
                    type="number"
                    value={parseNumber(item.ZDISC)}
                    onChange={(e) => handleInputChange(e, index, "ZDISC")}
                    className="w-full px-2 py-1 border rounded text-sm text-right"
                  />
                </td>
                <td className="border border-gray-300 px-2 py-2 text-right bg-blue-100">
                  <input
                    type="number"
                    value={parseNumber(item.FKIMG)}
                    onChange={(e) => handleInputChange(e, index, "FKIMG")}
                    className="w-full px-2 py-1 border rounded text-sm text-right"
                  />
                </td>
                <td className="border border-gray-300 px-2 py-2 text-right bg-blue-100">
                  <input
                    type="number"
                    value={parseNumber(item.ZPVAT)}
                    onChange={(e) => handleInputChange(e, index, "ZPVAT")}
                    className="w-full px-2 py-1 border rounded text-sm text-right"
                  />
                </td>
                <td className="border border-gray-300 px-2 py-2 text-right">
                  <input
                    type="number"
                    value={parseNumber(item.ZVAT)}
                    onChange={(e) => handleEditableFieldChange(e, index, "ZVAT")}
                    className="w-full px-2 py-1 border rounded text-sm text-right"
                  />
                </td>
                <td className="border border-gray-300 px-2 py-2 text-right">
                  <input
                    type="number"
                    value={parseNumber(item.ZPDISC)}
                    onChange={(e) => handleEditableFieldChange(e, index, "ZPDISC")}
                    className="w-full px-2 py-1 border rounded text-sm text-right"
                  />
                </td>
                <td className="border border-gray-300 px-2 py-2 text-right">
                  <input
                    type="number"
                    value={parseNumber(item.ZTAMT)}
                    onChange={(e) => handleEditableFieldChange(e, index, "ZTAMT")}
                    className="w-full px-2 py-1 border rounded text-sm text-right"
                  />
                </td>
                <td className="border border-gray-300 px-2 py-2 text-center">
                  <button
                    onClick={() => handleDeleteRow(index)}
                    className="bg-red-500 text-white px-2 py-1 rounded-md hover:bg-red-600 text-sm"
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <button
            onClick={handleAddRow}
            className="bg-green-500 text-white px-6 py-2 rounded-md shadow hover:bg-green-600"
          >
            Add New Row
          </button>
          <div className="flex justify-center items-center flex-col">

        {/* Checkbox and Message */}
        <div className="mt-4">
          <p className="text-gray-600">
          Please review and confirm that all newly entered values and calculations are accurate before proceeding with the invoice download.
          </p>
          <label className="flex items-center mt-2">
            <input
              type="checkbox"
              className="mr-2"
              checked={isChecked}
              onChange={(e) => setIsChecked(e.target.checked)}
            />
            I confirm all values are correct.
          </label>
        </div>

        {/* Buttons Section */}
        <div className="mt-4 mb-5 flex justify-between items-center">
        <button
        className="text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-5"
        onClick={() => setShowModal(true)}
      >
        SAVE INVOICE
      </button>
         <PDFGenerator data={data} isChecked={isChecked}/>
         <PDFGeneratorDuna data={data} isChecked={isChecked}/>
        </div>
        </div>
      </div>
      <ConfirmModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onConfirm={handleSubmit}
        title="Confirm Save"
        message="Are you sure you want to save the merged invoice and create a master invoice?"
        confirmText="Yes, Save"
        cancelText="Cancel"
        details ={true}
      />
    </div>
  );
};

export default MergedInvoiceTable;

